import { getNationalHoliday } from '../libs/cognito-api/national-holiday/national-holiday';

const { getHolidaysDateBeforeWorkingDays } = getNationalHoliday();

let _cachedD1: string | null = null;
let _cacheDay: string | null = null;

/**
 * Normalizes a date string or Excel date serial to ISO format (YYYY-MM-DD).
 * Accepts:
 *   - ISO:        "2026-09-30"   → "2026-09-30"
 *   - Brazilian:  "30/09/2026"   → "2026-09-30"
 *   - Excel:      46189          → "2026-06-16"
 * Throws if the input doesn't match either pattern.
 */
export function normalizeDate(raw: string | number): string {
  if (typeof raw === "number") return excelSerialDateToIso(raw);

  const s = raw.trim();

  if (/^\d+(\.\d+)?$/.test(s)) return excelSerialDateToIso(Number(s));

  // YYYY-MM-DD or YYYY-MM-DDTHH:mm:ss (Excel datetime serialized from cell reference)
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10);

  // DD/MM/YYYY
  const br = s.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (br) return `${br[3]}-${br[2]}-${br[1]}`;

  throw new Error(`Data inválida: "${raw}". Use DD/MM/AAAA ou AAAA-MM-DD.`);
}

function excelSerialDateToIso(serial: number): string {
  if (!Number.isFinite(serial) || serial <= 0) {
    throw new Error(`Data inválida: "${serial}". Use DD/MM/AAAA ou AAAA-MM-DD.`);
  }

  const wholeDays = Math.floor(serial);
  const excelEpoch = Date.UTC(1899, 11, 30);
  const date = new Date(excelEpoch + wholeDays * 24 * 60 * 60 * 1000);
  return date.toISOString().slice(0, 10);
}

/** Returns D-1 útil (yyyy-MM-dd), cached per calendar day. */
export async function getPreviousWorkingDay(): Promise<string> {
  const today = new Date().toISOString().slice(0, 10);
  if (_cachedD1 && _cacheDay === today) return _cachedD1;

  const response = await getHolidaysDateBeforeWorkingDays({ dateStart: today, workingDays: 1 });
  const d1 = response.data;
  if (!d1) throw new Error('Não foi possível obter D-1 útil da API de feriados');

  _cachedD1 = normalizeDate(d1);
  _cacheDay = today;
  return _cachedD1;
}
